// export const firebaseConfig = {
//   apiKey: "AIzaSyAE1UAeSqFLk8KVQ-rJFz6Fi_hul4ZQjmg",
//   authDomain: "ultimatum-f9099.firebaseapp.com",
//   databaseURL: "https://ultimatum-f9099.firebaseio.com",
//   projectId: "ultimatum-f9099",
//   storageBucket: "ultimatum-f9099.appspot.com",
//   messagingSenderId: "42716076245",
//   appId: "1:42716076245:web:00981da86171725bf36a5c",
//   measurementId: "G-6RQ61HDYPW"
// };
 // Your web app's Firebase configuration
// export const firebaseConfig = {
//    apiKey: "AIzaSyCev4ycC2FpUXua-nJYVLoeoTPr0TZHcbE",
//    authDomain: "ultimatum-temp.firebaseapp.com",
//    databaseURL: "https://ultimatum-temp.firebaseio.com",
//    projectId: "ultimatum-temp",
//    storageBucket: "ultimatum-temp.appspot.com",
//    messagingSenderId: "722126898430",
//    appId: "1:722126898430:web:f5ca3c4aa193d9e65791af",
//    measurementId: "G-WL3V2ZLXCY"
//  }
//  export const firebaseConfig = {
//    apiKey: "AIzaSyCeZaKyIEK37DPBgfrAL5ITTML5JR-R0Rg",
//    authDomain: "library-system-fe78b.firebaseapp.com",
//    databaseURL: "https://library-system-fe78b.firebaseio.com",
//    projectId: "library-system-fe78b",
//    storageBucket: "library-system-fe78b.appspot.com",
//    messagingSenderId: "260274564770",
//    appId: "1:260274564770:web:db127062acae7446bf71fb"
//  };

export const firebaseConfig = {
  apiKey: "AIzaSyDMSWJXbWuK5Da3HLcWIAjoIYJ7IxvOVoo",
  authDomain: "ultimatum-5c5e6.firebaseapp.com",
  databaseURL: "https://ultimatum-5c5e6.firebaseio.com",
  projectId: "ultimatum-5c5e6",
  storageBucket: "ultimatum-5c5e6.appspot.com",
  messagingSenderId: "573323748620",
  appId: "1:573323748620:web:6445c64b07f3d34d181529",
  measurementId: "G-YRQ7HXHNR1"
};

// export const firebaseConfig = {
//   apiKey: "AIzaSyCeZaKyIEK37DPBgfrAL5ITTML5JR-R0Rg",
//   authDomain: "library-system-fe78b.firebaseapp.com",
//   databaseURL: "https://library-system-fe78b.firebaseio.com",
//   projectId: "library-system-fe78b",
//   storageBucket: "library-system-fe78b.appspot.com",
//   messagingSenderId: "260274564770",
//   appId: "1:260274564770:web:db127062acae7446bf71fb"
// };

// export const firebaseConfig = {
//   apiKey: "AIzaSyDMSWJXbWuK5Da3HLcWIAjoIYJ7IxvOVoo",
//   authDomain: "ultimatum-5c5e6.firebaseapp.com",
//   databaseURL: "https://ultimatum-5c5e6.firebaseio.com",
//   projectId: "ultimatum-5c5e6",
//   storageBucket: "ultimatum-5c5e6.appspot.com",
//   messagingSenderId: "573323748620",
//   appId: "1:573323748620:web:6445c64b07f3d34d181529",
//   measurementId: "G-YRQ7HXHNR1"
// };
// export const firebaseConfig = {
//   apiKey: "AIzaSyDqpv_ySo8mlr7YrkxvqgkaOtDhqPMi5vA",
//   authDomain: "hello-5b711.firebaseapp.com",
//   databaseURL: "https://hello-5b711.firebaseio.com",
//   projectId: "hello-5b711",
//   storageBucket: "hello-5b711.appspot.com",
//   messagingSenderId: "491086858896",
//   appId: "1:491086858896:web:75120911dd2e35ec16a615",
//   measurementId: "G-E08E0GDTDM"
// };
// export const firebaseConfig = {
//   apiKey: "AIzaSyCWHRcdC1g5VZOGiixIb09_izIboPgbJDU",
//   authDomain: "crack-atlas-257614.firebaseapp.com",
//   databaseURL: "https://crack-atlas-257614.firebaseio.com",
//   projectId: "crack-atlas-257614",
//   storageBucket: "crack-atlas-257614.appspot.com",
//   messagingSenderId: "220581703304",
//   appId: "1:220581703304:web:e991be2d1b6057689b793d",
//   measurementId: "G-16XHPQBWXB"
// };



// WEBPACK FOOTER //
// ./src/environments/environment.ts